import React from "react";
import { AiOutlineCopyright } from "react-icons/ai";

const FooterBottom = () => {
  return (
    <div className="w-full bg-[#F5F5F3] group">
      <div className="max-w-container mx-auto border-t-[1px] pt-5 pb-5">
        <p className="text-titleFont font-normal text-center flex md:items-center justify-center text-lightText duration-200 text-sm">
         
          Copyright © {new Date().getFullYear()} HiNet Sistemas Todos los derechos reservados.
        </p>
      </div>
    </div>
  );
};

export default FooterBottom;
